import { Injectable } from "@angular/core";
import { ToasterNotificationService } from "./toaster-notification.service";
import { Observable, of } from "rxjs";
import { ErrorModel } from "../models/error.model";
import { environment } from "src/environments/environment";
import { SearchResultModel } from "../models/query/search-result-model";

const MYFILE_API_URL = `${environment.apiUrl}`;

@Injectable({
    providedIn: 'root'
})
export class BaseApiService {

    constructor(
        protected toasterNotificationService: ToasterNotificationService
    ) { }

    //added as returns for testing
    protected returnTrue(err: any): Observable<boolean> {
        return of(true);
    }

    protected returnModel(model: any): Observable<any> {
        return of(model);
    }

    protected returnSearchResultModel(model: any[]): Observable<any> {
        var searchResultModel: SearchResultModel<any> = new SearchResultModel(model, model.length);
        return of(searchResultModel);
    }

    /**
     * System Error API Service. Not used currently but should be 
     * implemented as a common error handler in all rest api calls.
     * @param err 
     * @returns 
     */
    protected handleError(err: any, showToasterError?: boolean): Observable<undefined> {
        if (showToasterError !== false) {
            if (err != undefined && err.status != 0 && err.error) {
                if (err.error instanceof ErrorModel) {
                    if (err.error && err.error.message) {
                        this.toasterNotificationService.showError(err.error.message, $localize`:@@Toast_Error_GeneralTitle:Error`);
                    } else {
                        this.toasterNotificationService.showError(err.error.Message, $localize`:@@Toast_Error_GeneralTitle:Error`);
                    }
                } else if (err.error instanceof Blob) {
                    var reader = new FileReader();
                    reader.addEventListener(
                        "load",
                        () => {
                            var resultModel = JSON.parse(`${reader.result}`);

                            if (resultModel.message) {
                                this.toasterNotificationService.showError(resultModel.message, $localize`:@@Toast_Error_GeneralTitle:Error`);
                            } else if (resultModel.Message) {
                                this.toasterNotificationService.showError(resultModel.Message, $localize`:@@Toast_Error_GeneralTitle:Error`);
                            } else {
                                this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
                            }
                        },
                        false,
                    );
                    reader.readAsText(err.error);
                } else {
                    if (err && err.error != undefined && err.error.message != undefined) {
                        this.toasterNotificationService.showError(err.error.message, $localize`:@@Toast_Error_GeneralTitle:Error`);
                    } else if (err && err.error != undefined && err.error.Message != undefined) {
                        this.toasterNotificationService.showError(err.error.Message, $localize`:@@Toast_Error_GeneralTitle:Error`);
                    } 
                    //I was hitting a weird race condition on this call https://luxxaiapi-dev.luxxai.com/v1/OCRServices/create-color-highlighted-search-terms-pdf saying it fails even though its returns 200 immediately. not sure whats going on to avoid random error commenting out this block for now. 
                    // else if (err.message) {
                    //     this.toasterNotificationService.showError(err.message, $localize`:@@Toast_Error_GeneralTitle:Error`);
                    // } else {
                    //     this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
                    // }
                }

            }
            else if (typeof err === "string") {
                this.toasterNotificationService.showError(err, $localize`:@@Toast_Error_GeneralTitle:Error`);
            }
            else {
                this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
            }
        }
        return of(undefined);
    }
}